
<script>
import { getUrlParam } from '@/common/js/common'
import { getScreenSize, getElementLeft, getElementTop } from '@/common/js/dom'
import * as echarts from 'echarts'
// 主题
const THEME_TYPE = [
  'healthy',
  'accident',
  'financing',
  'financing2',
  'financing3',
  'children',
  'diff'
]
const THEME_COLOR = [
  '#e58800',
  '#508cee',
  '#ce8b00',
  '#ce8b00',
  '#ce8b00',
  '#3dc4f6',
  '#ca0f0d'
]

export default {
  name: 'TrendChart',
  props: {
    insuredAge: {
      type: Number,
      default: 0
    },
    startYear: {
      type: Number,
      default: 0
    },
    curYear: {
      type: Number,
      default: 0
    },
    profit: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {}
  },
  computed: {
    // 起始年龄
    baseYear () {
      return this.startYear + this.insuredAge + 1
    },
    // 当前展示年龄
    showYear () {
      const { curYear, year, baseYear } = this
      return baseYear + (year > 0 && curYear === 0 ? year : curYear)
    }
  },
  watch: {
    profit: {
      handler (value) {
        const formatD = this.formatData(value)
        if (this.chart) {
          this.chart.clear()
        }
        this.chartRender(formatD)
      }
      // immediate: true
    }
  },
  created () {
    // 当前展示年龄
    this.year = parseInt(getUrlParam('year')) || 0
    // 主题颜色
    this.themeColor = this.getThemeColor()
    // 画板大小
    const size = getScreenSize()
    this.screenSize = {
      width: Math.min(size.width, 480),
      height: size.height
    }
  },
  mounted () {
    const formatD = this.formatData(this.profit)
    this.chartRender(formatD)
  },
  methods: {
    getThemeColor () {
      const theme = getUrlParam('theme')
      let themeIndex = THEME_TYPE.indexOf(theme)
      themeIndex = themeIndex > -1 ? themeIndex : 0
      return THEME_COLOR[themeIndex]
    },
    baseFixed (value) {
      const valueArray = (value + '').split('.')
      if (valueArray[1] && valueArray[1].length > 2) {
        return value.toFixed(2)
      }
      return value
    },
    formatData (d) {
      return d.map(item => {
        return {
          name: item.name,
          type: 'line',
          data: item.values || [],
          showSymbol: false
        }
      })
    },
    getCurYear (val) {
      const chartDom = document.getElementById('container')
      if (!chartDom) return
      const tooltipTextDom = chartDom.querySelector(
        '.chart-tooltip > div > div > div'
      )
      const curYear = parseInt(tooltipTextDom && tooltipTextDom.innerHTML)
      return !isNaN(curYear) ? curYear - this.baseYear : -1
    },
    chartRender (data) {
      const chartDom = document.getElementById('container')
      if (!chartDom) return
      if (this.chart) {
        this.chart.dispose()
        this.chart = null
      }
      const lengthArray = data.map(item => {
        return item.data.length
      })
      const xLen = Math.max(...lengthArray)
      const option = {
        tooltip: {
          triggerOn: 'none',
          confine: true,
          alwaysShowContent: true,
          className: 'chart-tooltip',
          extraCssText: 'z-index: 199',
          valueFormatter: value => {
            if (value < 10000) {
              return this.baseFixed(value)
            }
            if (value >= 10000) {
              return `${this.baseFixed(value / 10000)}万`
            }
            return value
          }
        },
        legend: {
          data: data.map(item => item.name)
        },
        grid: {
          left: '3%',
          right: '6%',
          bottom: 60,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisTick: {
            alignWithLabel: true
          },
          axisLabel: {
            interval: 100,
            showMinLabel: true,
            showMaxLabel: true
          },
          axisPointer: {
            value: `${this.showYear}岁`,
            snap: true,
            lineStyle: {
              color: '#ddd',
              width: 1
            },
            label: {
              show: true,
              backgroundColor: this.themeColor
            },
            handle: {
              show: true,
              size: 40,
              margin: 46,
              color: this.themeColor
            }
          },
          data: Array.from(
            { length: xLen },
            (i, index) => `${index + this.baseYear}岁`
          )
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: value => {
              return value >= 10000 ? `${value / 10000}万` : value
            }
          }
        },
        series: data
      }
      const chart = (this.chart = echarts.init(chartDom))
      // 限制至少选中一个图例
      chart.on('legendselectchanged', function (params) {
        let option = this.getOption()
        let select_value = Object.values(params.selected)
        if (select_value.every(val => !val)) {
          option.legend[0].selected[params.name] = true
        }
        this.setOption(option)
      })
      option && chart.setOption(option)
    }
  }
}
</script>
<template>
  <article class="demon-trend-chart">
    <div
      id="container"
      :style="{
        width: `${screenSize.width * 0.946}px`,
        height: `${screenSize.width}px`,
      }"
    />
  </article>
</template>
<style lang="postcss" scoped>
</style>
